const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/ordersubtno-disp/search', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
